import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import "react-phone-input-2/lib/style.css";
import { useState, useEffect } from "react";
import { useRegistration } from "../../../../context/RegistrationContext";
import { submitStep2, getRegistrationProgress, getStates, getCities, getBusinessConstitution } from "../../../../utils/gymOwnerApi";
import { useDispatch } from "react-redux";
import { Select2Data } from "../../../../utils/common";

const Create_Step2 = ({ step, totalSteps, setStep }) => {
  const { userId, setRegistrationData } = useRegistration();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const dispatch = useDispatch();
  const { control, handleSubmit, setValue, formState: { errors }, } = useForm({
    defaultValues: {
      gym_name: "",
      gym_brand_name: "",
      phone: "",
      alternate_phone: "",
      email: "",
      business_constitution_id: null,
      gym_address: "",
      city_id: null,
      state_id: null,
      pincode: "",
    },
  });
  const businessConstitutionOptions = [
    { value: 1, label: "Sole Proprietorship" },
    { value: 2, label: "Partnership Firm / LLP" },
    { value: 3, label: "Private Limited" },
    { value: 4, label: "Other (Please Specify)" },
  ];

  const cityOptions = [
    { value: 1, label: "Pune" },
    { value: 2, label: "Mumbai" },
    { value: 3, label: "Delhi" },
  ];

  const stateOptions = [
    { value: 1, label: "Maharashtra" },
    { value: 2, label: "Gujarat" },
    { value: 3, label: "Delhi" },
  ];

  useEffect(() => {
    const loadProgress = async () => {
      if (userId) {
        setLoadingData(true);
        try {
          const response = await getRegistrationProgress();
          if (response.success && response.data?.gym_detail) {
            const gymDetail = response.data.gym_detail;
            setValue("gym_name", gymDetail.gym_name || "");
            setValue("gym_brand_name", gymDetail.gym_brand_name || "");
            setValue("phone", gymDetail.phone || "");
            setValue("alternate_phone", gymDetail.alternate_phone || "");
            setValue("email", gymDetail.email || "");
            setValue("business_constitution_id", gymDetail.business_constitution_id || null);
            setValue("gym_address", gymDetail.gym_address || "");
            fetchCity(gymDetail?.state_id)
            setValue("city_id", gymDetail.city_id || null);
            setValue("state_id", gymDetail.state_id || null);
            setValue("pincode", gymDetail.pincode || "");
            setRegistrationData(response.data);
          }
        } catch (error) {
          console.error("Error loading progress:", error);
        } finally {
          setLoadingData(false);
        }
      }
    };
    loadProgress();
  }, [userId, setValue, setRegistrationData]);

  const onSubmit = async (data) => {
    if (!userId) {
      alert("Please complete step 1 first");
      setStep(1);
      return;
    }

    setLoading(true);
    try {
      const step2Data = {
        user_id: userId,
        gym_name: data.gym_name,
        gym_brand_name: data.gym_brand_name,
        phone: data.phone?.replace(/\D/g, "") || data.phone,
        alternate_phone: data.alternate_phone?.replace(/\D/g, "") || data.alternate_phone,
        email: data.email,
        business_constitution_id: data.business_constitution_id?.value || data.business_constitution_id,
        gym_address: data.gym_address,
        city_id: data.city_id?.value || data.city_id,
        state_id: data.state_id?.value || data.state_id,
        pincode: data.pincode,
      };
      await submitStep2(step2Data);
      setStep(3);
    } catch (error) {
      console.error("Error submitting step 2:", error);
    } finally {
      setLoading(false);
    }
  };


  const [states, setStates] = useState([]);
  const [city, setCity] = useState([]);
  const [bc, setBc] = useState([]);
  const fetch = async () => {
    const resState = await getStates()

    if (resState?.success) {
      const res = await Select2Data(resState?.data, "state_id");
      setStates(res);
      console.log({ res });
    }
    const resBc = await getBusinessConstitution()

    if (resBc?.success) {
      const res = await Select2Data(resBc?.data, "business_constitution_id");
      setBc(res);

    }
  }

  const fetchCity = async (id) => {
    const resState = await getCities(id)
    if (resState?.success) {
      const res = await Select2Data(resState?.data, "city_id");
      setCity(res);
    }
  }

  useEffect(() => { fetch() }, [])
  return (
    <section className="step2_wrapper step1_wrapper">
      <Form_Header
        title="Gym Business Details"
        subtitle=""
        step={2}
        totalSteps={7}
      />

      <div className="container">
        {loadingData ? (
          <div className="text-center py-5">
            <p>Loading saved data...</p>
          </div>
        ) : (
          <Form className="auth_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Gym / Business Legal Name *</Form.Label>
                  <Controller
                    name="gym_name"
                    control={control}
                    rules={{ required: "Gym name is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Gym / Business Name as per registration"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.gym_name?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Gym Brand / Display Name *</Form.Label>
                  <Controller
                    name="gym_brand_name"
                    control={control}
                    rules={{ required: "Brand name is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Name to be displayed on the GYMIFY App"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.gym_brand_name?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6">
                <Form.Group className="mb-3">
                  <Form.Label>Business Contact *</Form.Label>
                  <Controller
                    name="phone"
                    control={control}
                    rules={{ required: "Contact number is required" }}
                    render={({ field }) => (
                      <PhoneInput
                        country="in"
                        value={field.value}
                        onChange={field.onChange}
                        specialLabel=""
                        enableSearch
                        inputClass="phone_input"
                        containerClass="phone_container"
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.phone?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6">
                <Form.Group className="mb-3">
                  <Form.Label>Alternate Phone</Form.Label>
                  <Controller
                    name="alternate_phone"
                    control={control}
                    render={({ field }) => (
                      <PhoneInput
                        country="in"
                        value={field.value}
                        onChange={field.onChange}
                        specialLabel=""
                        enableSearch
                        inputClass="phone_input"
                        containerClass="phone_container"
                        placeholder="Phone Number"
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.alternate_phone?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6">
                <Form.Group className="mb-4">
                  <Form.Label>Business Email Id *</Form.Label>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                        message: "Enter a valid email address",
                      }
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="email"
                        placeholder="Enter Email Address"
                        {...field}
                      />
                    )}
                  />

                  <div className="text-danger">
                    {errors.email?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Business Constitution *</Form.Label>
                  <Controller
                    name="business_constitution_id"
                    control={control}
                    rules={{ required: "Business Constitution is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={bc}
                        value={bc.find(
                          (opt) => opt.value === field.value
                        )}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.business_constitution_id?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label>Business Address *</Form.Label>
                  <Controller
                    name="gym_address"
                    control={control}
                    rules={{ required: "Address is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Gym Address"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.gym_address?.message}
                  </div>
                </Form.Group>
              </div>
              <div className="col-lg-6 mt-4">
                <Form.Group>
                  <Form.Label>State *</Form.Label>

                  <Controller
                    name="state_id"
                    control={control}
                    rules={{ required: "State is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={states}
                        value={states.find(
                          (opt) => opt.value === field.value
                        )}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);
                          fetchCity(selectedOption.value)
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.state_id?.message}
                  </div>
                </Form.Group>
              </div>
              <div className="col-lg-6 mt-4">
                <Form.Group>
                  <Form.Label>City *</Form.Label>
                  <Controller
                    name="city_id"
                    control={control}
                    rules={{ required: "City is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={city}
                        value={city.find(
                          (opt) => opt.value === field.value
                        )}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.city_id?.message}
                  </div>
                </Form.Group>
              </div>



              <div className="col-lg-6 mt-4">
                <Form.Group>
                  <Form.Label>Pin Code *</Form.Label>
                  <Controller
                    name="pincode"
                    control={control}
                    rules={{ required: "Pin code is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Pin"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.pincode?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="form_btn_holder">
                {!loadingData && <>
                  <White_Btn btnText={"Back"} onClick={() => setStep(1)} />
                  <Common_Btn
                    btnText={loading ? "Submitting..." : "Next"}
                    type="submit"
                    disabled={loading}
                  />
                </>
                }
              </div>
            </div>
          </Form>
        )}
      </div>
    </section>
  );
};

export default Create_Step2;
